var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalFlavorSolid = function SvgLocalFlavorSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.25c-1.027 0-1.99.463-2.684 1.25-.69.783-1.066 1.828-1.066 2.9v6.8c0 1.072.375 2.117 1.066 2.9.694.787 1.657 1.25 2.684 1.25h1.662l2.776 3.146a.75.75 0 0 0 1.124 0l2.777-3.146H17c1.027 0 1.99-.463 2.684-1.25.69-.783 1.066-1.828 1.066-2.9V7.4c0-1.072-.375-2.117-1.066-2.9-.694-.787-1.657-1.25-2.684-1.25H7Zm5 3.5a.25.25 0 0 1 .214.121l1.468 2.447 2.447 1.468a.25.25 0 0 1 0 .428l-2.447 1.468-1.468 2.447a.25.25 0 0 1-.428 0l-1.468-2.447-2.447-1.468a.25.25 0 0 1 0-.428l2.447-1.468 1.468-2.447A.25.25 0 0 1 12 6.75Z",
    fill: "currentColor"
  })));
};
export default SvgLocalFlavorSolid;